module.exports = __webpack_public_path__ + "static/img/3.38e10af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-h5/3.jpg
// module id = Ynev
// module chunks = 2